import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import type {ServerTableEmptyStateProps} from "../types";

const ServerTableEmptyState = ({columnCount, type, presentation}: ServerTableEmptyStateProps) => {
    const {t} = useTranslation();
    // Embedded tables sit beside other content in a dialog or card, where a full placeholder
    // block would outweigh what it reports. Same message, one quiet line.
    const embedded = presentation === 'embedded';
    const content = type === 'search'
        ? {
            icon: <SearchOffOutlinedIcon/>,
            title: t('No matching results'),
            description: t('Nothing matches your current search or filters.')
        }
        : type === 'filter'
            ? {
                icon: <FilterAltOffOutlinedIcon/>,
                title: t('No results for these filters'),
                description: t('Adjust or remove filters to see more results.')
            }
            : {
                icon: <InboxOutlinedIcon/>,
                title: t('No entries found'),
                description: t('There are no entries to display.')
            };

    return (
        <Box component="tr">
            <Box component="td" colSpan={columnCount} sx={{p: 0, borderBottom: 'none'}}>
                {/* Pin to the visible viewport width (not the full scrolled table width) so the message
                    stays centered in view when the table scrolls horizontally. Mirrors the pagination. */}
                <Box sx={{position: 'sticky', left: 0, width: 'var(--server-table-viewport-width, 100%)'}}>
                    <Stack
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                        sx={{height: embedded ? 88 : 200, color: 'text.secondary', textAlign: 'center'}}
                    >
                        {!embedded && content.icon}
                        <Typography variant={embedded ? 'body2' : 'subtitle2'} color={embedded ? 'inherit' : 'text.primary'}>
                            {content.title}
                        </Typography>
                        {!embedded && (
                            <Typography variant="body2">
                                {content.description}
                            </Typography>
                        )}
                    </Stack>
                </Box>
            </Box>
        </Box>
    );
};

export default ServerTableEmptyState;
